@use './variables' as *;
@use '../../styles/abstracts' as *;

:host {
  display: block;
  margin-bottom: $question-group-margin-bottom;
}

air-button {
  width: $question-group-button-width;
}

.question-group {
  width: $question-group-width;
}

.question-group-controls {
  max-width: $question-group-controls-max-width;
  margin-top: $question-group-controls-margin-top;
  margin-right: $question-group-controls-margin-right;
  margin-bottom: $question-group-controls-margin-bottom;
  margin-left: $question-group-controls-margin-left;
}

.question-group-controls.secondary {
  display: flex;
  justify-content: $question-group-controls-secondary-justify;
  a:last-child {
    margin-left: $question-group-controls-secondary-spacing;
  }
  min-width: $question-group-controls-secondary-min-width;
}

.question-group-controls air-divider {
  width: $question-group-controls-max-width;
  margin-top: $question-group-controls-divider-margin-top;
  margin-right: $question-group-controls-divider-margin-right;
  margin-bottom: $question-group-controls-divider-margin-bottom;
  margin-left: $question-group-controls-divider-margin-left;
}

.add-question-button {
  margin-top: $question-group-button-add-margin-top;
  margin-right: $question-group-button-add-margin-right;
  margin-bottom: $question-group-button-add-margin-bottom;
  margin-left: $question-group-button-add-margin-left;
}

.remove-question-button {
  margin-top: $question-group-button-remove-margin-top;
  margin-right: $question-group-button-remove-margin-right;
  margin-bottom: $question-group-button-remove-margin-bottom;
  margin-left: $question-group-button-remove-margin-left;
}

.air-link {
  font-family: $question-group-link-font-family;
  text-decoration: $question-group-link-text-decoration;
  color: $question-group-link-color;
}

.air-link:visited {
  color: $question-group-link-visited-color;
}

.air-link:hover {
  color: $question-group-link-hover-color;
  cursor: pointer;
}

.air-link:focus {
  color: $question-group-link-focus-color;
  outline: $question-group-link-focus-outline;
}

.air-link:active {
  color: $question-group-link-active-color;
}

.air-link-secondary {
  font-family: $question-group-link-font-family;
  text-decoration: $question-group-link-secondary-text-decoration;
  color: $question-group-link-secondary-color;
}

.air-link-secondary:visited {
  color: $question-group-link-secondary-visited-color;
}

.air-link-secondary:hover {
  text-decoration: $question-group-link-secondary-hover-text-decoration;
  color: $question-group-link-secondary-hover-color;
  cursor: pointer;
}

.air-link-secondary:focus {
  color: $question-group-link-secondary-focus-color;
  outline: $question-group-link-focus-outline;
}

.air-link-secondary:active {
  color: $question-group-link-secondary-active-color;
}

@media (max-width: $breakpoint-mobile) {
  .button {
    width: $mobile-question-group-button-width;
  }

  .question-group,
  .question-group-controls,
  .question-group-controls air-divider {
    width: $mobile-question-group-width;
    max-width: $mobile-question-group-width;
  }
}
